import { combineReducers } from 'redux';
import projectSetup from './project-setup/project-setup.reducer';
import questionnaire from './questionnaire/questionnaire.reducer';
import questions from './questions/questions.reducer';

const rootReducer = combineReducers({ projectSetup, questionnaire, questions });

export default rootReducer;
